import Cookies from 'js-cookie';
import { apiFetch } from '../../services/api';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001';

const PharmacyService = {
  // Add a new pharmacy
  async addPharmacy(pharmacyData, files) {
    const payload = {
      ...pharmacyData,
      profilePath: files.profilePhoto || undefined,
      medicalLicense_path: files.license || undefined,
      auth_sign: files.authorizedSignature || undefined,
      commercialLicense_path: files.commercialLicense || undefined,
    };

    try {
      const response = await apiFetch(`${API_BASE_URL}/admin/addPharmacy`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to add pharmacy');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error adding pharmacy: ${error.message}`);
    }
  },

  // Update an existing pharmacy
  async updatePharmacy(pharmacyId, pharmacyData, files) {

    const payload = {
      ...pharmacyData,
      profilePath: files.profilePhoto || undefined,
      medicalLicense_path: files.license || undefined,
      auth_sign: files.authorizedSignature || undefined,
      commercialLicense_path: files.commercialLicense || undefined,
    };


    try {
      const response = await apiFetch(`${API_BASE_URL}/admin/updatePharmacy/${pharmacyId}`, {
        method: 'PUT',
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to update pharmacy');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error updating pharmacy: ${error.message}`);
    }
  },

  // Delete a pharmacy
  async deletePharmacy(pharmacyId) {
    try {
      const response = await apiFetch(`${API_BASE_URL}/admin/deletePharmacy/${pharmacyId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Failed to delete pharmacy');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error deleting pharmacy: ${error.message}`);
    }
  },

  // Upload profile photo independently
  async uploadProfilePhoto(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('module_id', '1');
    formData.append('pathLocation', 'PROFILE_IMAGES/');

    // Debug FormData contents
    console.log('FormData contents for uploadProfilePhoto:');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value instanceof File ? value.name : value}`);
    }

    try {
      const response = await apiFetch(`${API_BASE_URL}/admin/awsS3FileUpload`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to upload profile photo: ${response.status} ${response.statusText} - ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error uploading profile photo: ${error.message}`);
    }
  },


  async getAllPharmacy() {

    try {
      const adminId = Cookies.get('adminid') || localStorage.getItem('adminid');
      if (!adminId) {
        throw new Error('Admin ID not found in cookies');
      }
      const response = await apiFetch(`${API_BASE_URL}/admin/admingetpharmacydetails/${adminId}`);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch clinics: ${response.status} ${response.statusText} - ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error fetching clinics: ${error.message}`);
    }
  },

  async getPharmacyAppointments(pharmacyId) {
    const payload = {
      pharmacyId: pharmacyId,
    };

    try {
      const response = await apiFetch(`${API_BASE_URL}/pharmacy/getPharmacyAppointments`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch appointments: ${response.status} ${response.statusText} - ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error fetching appointments: ${error.message}`);
    }
  }
};

export default PharmacyService;